module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_check-67a5f954de6047c88bcd4b8460c57748.svg";